import React from 'react';
import * as Yup from 'yup';
import _ from 'lodash';
import { FormContainer } from '~/views/companies/styles';
import { isValidCnpj } from '~/helper';
import Tabs from '~/components/tabs';
import { TabPersons } from '~/views/companies/tab-persons';
import { TabGeneral } from '~/views/companies/tab-general';

export const CompanySchema = Yup.object().shape({
  user: Yup.object().shape({
    name: Yup.string().required('Informe o nome do responsável'),
  }),
  name: Yup.string().min(4, 'Verifique se a razão social está correto').required('Informe a razão social'),
  tradeName: Yup.string().min(4, 'Verifique se a nome fantasia está correto').required('Informe a nome fantasia'),
  identify: Yup.mixed().test('', 'Informe o CPF ou Número de registro', function(value) {
    let parent = this.parent || {};

    if (!parent.source || parent.source === 'national') {
      return value && isValidCnpj(value);
    }
    return !!value;
  }),
  email: Yup.string().email('Informe um email válido').required('Informe o Email'),
});

const tabs = [
    { id: 'general', label: 'Dados gerais', component: TabGeneral },
    { id: 'persons', label: 'Colaboradores', component: TabPersons },
  ];

export const CompanyForm = (args) => {

  return (
    <FormContainer>
      <Tabs
        tabs={tabs}
        initialTab="general"
        persons={_.get(args, 'values.persons') || []}
        {...args}
        />
    </FormContainer>
  );
};
